import AppEvents from 'Shared/app-events';
import ds from 'Shared/ds';
import modal from 'Shared/modal';

export default class ProfileApi {

    static onChanged = handler => AppEvents.on(this.Events.PROFILE_CHANGED, handler);
    static changed = (result) => AppEvents.emit(this.Events.PROFILE_CHANGED, result);

    static onSelect = handler => AppEvents.on(this.Events.PROFILE_SELECT, handler);
    static select = (id) => AppEvents.emit(this.Events.PROFILE_SELECT, { id: id });

    static data = (data) => ds.get(this.#const.DATA, data);
    static detail = (id) => ds.get(`${this.#const.DETAIL}/${id}`);

    static import = (data) => modal.load(this.#const.PROFILE_IMPORT, data)
        .done(this.changed);
 
    static #const = {
        DATA: "/profile/data",
        DETAIL: "/profile/detail",
        PROFILE_CREATE: "/profile/create",
        PROFILE_EDIT: "/profile/edit",
        PROFILE_DELETE: "/profile/delete",
        PROFILE_IMPORT: "/profile/importcontact"
    };

    static Events = {
        PROFILE_CREATE: "profile-create",
        PROFILE_EDIT: "profile-edit",
        PROFILE_DELETE: "profile-delete",
        PROFILE_CHANGED: "profile-changed",
        PROFILE_SELECT: "profile-select"
    };
}